import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { bool, func, object, string } from 'prop-types';
import cn from 'classnames';

import { DropDown, SvgParser } from '../../../elements';
import { ReactComponent as Arrow } from '../../../styles/icon/arrow-pink.svg';
import dropdown from '../../../elements/DropDown/DropDown.module.scss';
import useResponsive from '../../../hooks/useResponsive';
import docs from '../CombinedDocs.module.scss';

const mapStateToProps = (state) => ({
  location: state.router.location,
  sdkPageId: state.ghost.sdkPageId,
  sdkPostId: state.ghost.sdkPostId,
});

const mapDispatchToProps = {};

SdkPage.propTypes = {
  data: object,
  loadSdkContent: func,
  sdkPageId: string,
  sdkPostId: string,
  preventClosingMenu: func,
  isSdkClick: bool
};

function SdkPage(props) {
  const [activePage, setActivePage] = useState('');
  const [isOpen, handleDropDown] = useState(false);
  const { data, loadSdkContent, location, sdkPageId, sdkPostId, preventClosingMenu, isSdkClick } = props;
  const { posts = [], title = '', slug = '', id, featureImage = '' } = data;
  const { isMobile } = useResponsive();

  useEffect(() => {
    if (location.pathname.indexOf('/docs/sdks') === -1) {
      setActivePage('');
      handleDropDown(false)
    } else {
      /**
        @property {isSdkClick} bool - allows to open the accordion if the click was on it, prevents it from being opened on page load or redirect by a link
        @property {sdkPostId} string - if an internal page was opened, this variable allows the accordion to be opened on page load
      */
      if (isSdkClick || sdkPostId) {
        if (posts && !!posts.length) {
          handleDropDown(sdkPageId === slug);
        }

        if (!sdkPostId) {
          setActivePage(slug === sdkPageId ? sdkPageId : '')
        }

        if (!!sdkPostId) {
          setActivePage(slug === sdkPostId ? sdkPostId : '');
        }
      }
    }
  }, [isSdkClick, location, posts, sdkPageId, sdkPostId, slug]);
  const isActive = location.pathname == `/docs/sdks/${slug}`;

  return (
    <div
      className={cn(docs.docs__list_item, {
        [docs['docs__list_item--active']]: activePage == slug || isOpen || isActive,
      })}
    >
      {!posts.length ? (
        <Link to={`/docs/sdks/${slug}`}>
          <div className={docs.docs__link_content}>
            {featureImage && (
              <SvgParser
                src={featureImage}
                title={title}
              />
            )}
            <span>{title}</span>
          </div>
        </Link>
      ) : (
        <DropDown
          className={dropdown.dropdown__full_width}
          classNameTrigger={cn({
            [docs['docs__link_menu--active']]: activePage == slug,
            [docs['docs__link_menu--open']]: isOpen,
          })}
          classNameBody={dropdown.dropdown__doc}
          trigger={() => (
            <div
              className={cn(docs.docs__link_menu, {
                'accordion-menu-show': isOpen,
                'accordion-menu-hide': !isOpen && isActive,
              })}
            >
              <div className={docs.docs__accordion}>
                <div className={docs.docs__accordion_title}>
                  <Link to={`/docs/sdks/${slug}`}>
                    {featureImage && (
                      <SvgParser
                        src={featureImage}
                        title={title}
                      />
                    )}
                    <span>{title}</span>
                  </Link>
                </div>
                <div
                  className={docs.docs__accordion_arrow}
                  onClick={() => {
                    if (activePage !== slug && !isOpen) {
                      props.history.push(`/docs/sdks/${slug}`);
                      // loadSdkContent({ id, type: 'pages', sdkPageId: slug, sdkPostId: '' });
                    } else {
                      //when the accordion closes need to load the content for the main page
                      loadSdkContent({ id, type: 'pages', sdkPageId: '', sdkPostId: '' });
                    }
                    setActivePage('');

                    if (isMobile && !isOpen) {
                      preventClosingMenu();
                    }
                  }}
                >
                  <Arrow />
                </div>
              </div>
            </div>
          )}
          isOpened={isOpen}
          handleClose={() => {}}
        >
          {posts.map((post, i) => {
            const pathname = location.pathname.slice(11, location.pathname.length);
            const isActive = pathname === `${slug}/${post.slug}`;
            return (
              <div
                key={i}
                className={cn(docs.docs__link_menu_item, {
                  [docs['docs__link_menu_item--active']]: isActive,
                })}
                // onClick={() => {
                //   loadSdkContent({
                //     id: post.id,
                //     type: 'posts',
                //     sdkPageId: slug,
                //     sdkPostId: post.id,
                //   });
                // }}
              >
                <Link to={`/docs/sdks/${slug}/${post.slug}`}>
                  {post.featureImage && (
                    <div
                      className={docs.docs__sub_icon}
                    >
                      <SvgParser
                        cacheRequests={true}
                        description={post.title}
                        src={post.featureImage}
                        title={post.title}
                      />
                    </div>
                  )}
                  <span>{post.title}</span>
                </Link>
              </div>
            );
          })}
        </DropDown>
      )}
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SdkPage));
